import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";
import { BreakPointDesktop } from "../../../constants/dimension";
import { isTV } from "../../../utils/platform";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    placeContent: "center",
    position: "relative",
    cursor: "pointer",
    overflow: "hidden",
    border: `none`,
    background: theme.colors.Primary,
    color: theme.colors.TextDefault,
    textAlign: "-webkit-center",
    fontWeight: theme.fontWeight.medium,
    fontSize: 12,
    padding: theme.spacing.space8,
    fontFamily: "Poppins",
    boxSizing: "border-box",
    width: "fit-content",
    gap: theme.spacing.space8,
    borderRadius: theme.radius.button,
    [BreakPointDesktop]: {
      fontSize: 16,
      padding: `${theme.spacing.space12}px ${theme.spacing.space20}px`,
      fontWeight: theme.fontWeight.semiBold,
    },
    "& > span": {
      "&.ripple": {
        position: "absolute",
        borderRadius: "50%",
        transform: "scale(0)",
        animation: "$ripple 600ms linear",
        backgroundColor: "rgba(255, 255, 255, 0.7)",
      },
    },
    "&.only-icon": {
      borderRadius: "50%",
      padding: `${theme.spacing.space8}px !important`,
      cursor: "auto",
    },
    "&.fullWidth": {
      width: "100%",
    },
    "&.xSmall": {
      fontWeight: theme.fontWeight.medium,
      fontSize: 12,
      padding: `${theme.spacing.space8}px ${theme.spacing.space12}px`,
    },
    "&.small": {
      fontWeight: theme.fontWeight.medium,
      fontSize: 14,
      padding: `${theme.spacing.space8}px ${theme.spacing.space16}px`,
    },
    "&.extraLarge": {
      fontSize: 16,
      padding: `${theme.spacing.space12}px ${theme.spacing.space20}px`,
      fontWeight: theme.fontWeight.semiBold,
      [BreakPointDesktop]: {
        fontSize: 24,
        fontWeight: theme.fontWeight.bold,
        padding: `${theme.spacing.space16}px ${theme.spacing.space20}px`,
      },
    },
    "&.outlined": {
      background: "transparent",
      color: theme.colors.TextDefault,
      border: `1px solid ${theme.colors.Border3}`,
    },
    "&.borderless": {
      background: "transparent",
      color: theme.colors.TextDefault,
    },
    "&.disabled": {
      background: theme.colors.ButtonDisable,
      color: theme.colors.TextGray,
      border: "none",
      pointerEvents: "none",
    },
    "@media (hover: hover) and (pointer: fine)": {
      "&.contained": {
        "&:hover": {
          background: "#1154A7",
        },
      },
      "&:hover": {
        background: "#3F3F3F",
      },
    },
  },
  overlay: {
    position: "absolute",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
  },
  active: {
    outline: `2px solid ${theme.colors.Border4}`,
    outlineOffset: 2,
  },
  iconSize: {
    zIndex: 1,
    paddingInlineStart: theme.spacing.space8,
    fontSize: 24,
    "&.small": {
      paddingInlineStart: theme.spacing.space4,
      lineHeight: "24px",
    },
    "&.only-icon": {
      paddingInlineStart: 0,
      width: theme.spacing.space40,

      "&.large": {
        fontSize: theme.spacing.space32,
        lineHeight: "32px",
      },
    },
  },
  hoverActive: {
    overflow: "unset",
    border: "2px solid transparent",
    "&:hover": {
      "&:after": {
        content: `""`,
        position: "absolute",
        inset: -6,
        padding: 2,
        ...(isTV
          ? { border: "2px solid rgba(255, 255, 255, 0.6)" }
          : {
              background:
                "linear-gradient(108.87deg, rgba(255, 255, 255, 0.8) 0.66%, rgba(211, 211, 211, 0.25) 99.48%)",
              WebkitMask:
                "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
              WebkitMaskComposite: "xor",
            }),
        borderRadius: 6,
      },
    },
  },
  "@keyframes ripple": {
    to: {
      transform: "scale(3)",
      opacity: 0,
    },
  },
}));
